<template>
  <div class id="Configure">
    <!-- <mt-header fixed title="车辆配置">
      <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
    </mt-header> -->
    <div class="basic">
    <van-cell-group title="基础信息">
      <van-cell v-if="resData.carBrandName" title="品牌车系" :value="resData.carBrandName + resData.carSeriesName" />
      <van-cell v-if="GET_DICT(1,resData.type)" title="车辆类型" :value="GET_DICT(1,resData.type)" />
      <van-cell v-if="resData.mileage" title="里程数" :value="resData.mileage + '万公里'" />
      <van-cell v-if="resData.firstLicenseDate" title="初次上牌" :value="resData.firstLicenseDate" />
      <van-cell v-if="GET_DICT(3,table.carColor)" title="车辆颜色" :value="GET_DICT(3,table.carColor)" />
      <van-cell v-if="GET_DICT(4,table.interiorColor)" title="内饰颜色" :value="GET_DICT(4,table.interiorColor)" />
      <van-cell v-if="resData.cityName" title="车辆所在地" :value="resData.cityName" />
      <van-cell v-if="GET_DICT(12,table.carUsageMode)" title="使用性质" :value="GET_DICT(12,table.carUsageMode)" />
    </van-cell-group>
    <van-cell-group title="参数配置">
      <van-cell v-if="GET_DICT(7,table.airIntakeMethod)" title="排气方式" :value="GET_DICT(7,table.airIntakeMethod)" />
      <van-cell v-if="GET_DICT(8,table.carOilSystemList)" title="供油系统" :value="GET_DICT(8,table.carOilSystemList)" />
      <van-cell v-if="GET_DICT(5,table.emissionsStandardList)" title="排放标准" :value="GET_DICT(5,table.emissionsStandardList)" />
      <van-cell v-if="GET_DICT(10,table.carDriverTypeList)" title="驱动形式" :value="GET_DICT(10,table.carDriverTypeList)" />
      <van-cell v-if="resData.outputVolumne" title="排量" :value="resData.outputVolumne" />
      <van-cell v-if="GET_DICT(9,table.carGearboxTypeList)" title="变速箱" :value="GET_DICT(9,table.carGearboxTypeList)" />
      <van-cell v-if="GET_DICT(6,table.carBodyType)" title="车体形式" :value="GET_DICT(6,table.carBodyType)" />
    </van-cell-group>
    <van-cell-group title="手续信息">
      <van-cell v-if="GET_DICT(13,table.purchaseTaxList)" title="购置税" :value="GET_DICT(13,table.purchaseTaxList)" />
      <van-cell v-if="resData.drivingPermit" title="行驶证" :value="resData.drivingPermit" />
      <van-cell v-if="resData.regiestationCertificate" title="登记证" :value="resData.regiestationCertificate" />
      <van-cell v-if="resData.pontageDate" title="路桥费到期" :value="resData.pontageDate" />
      <van-cell v-if="resData.vehicleDueDate" title="车船费到期" :value="resData.vehicleDueDate" />
      <van-cell v-if="resData.inspectionDueDate" title="年检到期" :value="resData.inspectionDueDate" />
      <van-cell v-if="resData.compulsoryInsuranceDueDate" title="交强险到期" :value="resData.compulsoryInsuranceDueDate" />
      <van-cell v-if="resData.commercialInsuranceDueDate" title="商业险到期" :value="resData.commercialInsuranceDueDate" />
      <van-cell v-if="resData.newCarInvoice" title="新车发票" :value="resData.newCarInvoice" />
      <van-cell v-if="resData.newCarGuarantee" title="新车保质" :value="resData.newCarGuarantee" />
      <van-cell v-if="resData.keyNumber" title="钥匙" :value="resData.keyNumber" />
    </van-cell-group>
    </div>
  </div>
</template>

<script>
/**
 * carModelName - 标题（车辆名称）
 * mileage - 公里数
 * newCarPrice - 新车价
 * price - 车价
 * type - 车辆类型  1（新车） 2（二手车）
 * carOilSystemLabel - 燃气形式/供油系统
 * carDriverTypeLabel - 驱动方式
 * carPlateCityName - 车辆所在城市
 * emissionsStandardsLabel - 排放标准
 * carGearboxTypeLabel - 变速箱
 * outputVolumne - 排放量
 * firstLicenseDate - 初次上牌时间
 * carColor - 车系颜色
 * interiorColor - 内饰颜色
 * vinCode - VIN码
 * carBrandName - 车辆品牌
 * carSeriesName - 车系名称
 * carImages - 图片集合
 * airIntakeMethodLabel - 进气方式
 */
import { Swipe, SwipeItem, Header } from "mint-ui";
import {
  API_GET,
  API_POST,
  getLocation,
  getToken,
  API_GET_TOKEN,
  GET_DICT
} from "@/apiConfig";
export default {
  name: "Configure",
  data() {
    return {
      resData: {
        carBrandName:"",
        carSeriesName:"",
        type:"",
        mileage:"",
        firstLicenseDate:"",
        cityName:"",
        outputVolumne:"",
        drivingPermit:"",
        regiestationCertificate:"",
        pontageDate:"",
        vehicleDueDate:"",
        inspectionDueDate:"",
        compulsoryInsuranceDueDate:"",
        commercialInsuranceDueDate:"",
        newCarInvoice:"",
        newCarGuarantee:"",
        keyNumber:""
      },
      GET_DICT: function() {},
      table:{
        carColor:"", //车辆颜色
        interiorColor: "", //内饰颜色
        carUsageMode: "", //使用性质
        airIntakeMethod:"",//排气方式
        carOilSystemList:"",//供油系统
        emissionsStandardList:"",//排放标准
        carDriverTypeList:"",//驱动形式
        carGearboxTypeList:"",//变速箱
        purchaseTaxList:"",//购置税
        carBodyType:"",//车体形式
      }
    };
  },
  mounted() {
    this.fetchData();
    // this.getDict()
    window.scroll(0, 0);
    this.GET_DICT = GET_DICT;
  },
  methods: {
    goback: function() {
      window.history.go(-1);
    },

    getDict: function() {
      //获取数据字典
      API_GET_TOKEN("/lianlianche-car/carEnumDictionary/list", {}).then(res => {
        if (res.status == 0) {
          this.resData = res.data;
        } else {
            message: res.msg
        }
      });
    },

    fetchData: function() {
      let body = {
        carId: this.$route.params.id
      };
      if (body.carId != null) {
        this.loading = true;
        API_GET("/lianlianche-car/car/getCarInfoDetail", body).then(res => {
          if (res.status == 0) {
            this.resData = res.data;
            this.table.interiorColor = res.data.interiorColorList[0].classId
            this.table.carColor = res.data.carColorList[0].classId
            this.table.carUsageMode = res.data.carUsageModeList[0].classId
            this.table.airIntakeMethod = res.data.airIntakeMethodList[0].classId
            this.table.carOilSystemList = res.data.carOilSystemList[0].classId
            this.table.emissionsStandardList = res.data.emissionsStandardList[0].classId
            this.table.carDriverTypeList = res.data.carDriverTypeList[0].classId
            this.table.carGearboxTypeList = res.data.carGearboxTypeList[0].classId
            this.table.purchaseTaxList = res.data.purchaseTaxList[0].classId
            this.table.carBodyType = res.data.carBodyType[0].classId
            if (res.data.drivingPermit === 1) {
							this.resData.drivingPermit = "有"
						} else if (res.data.drivingPermit === 2) {
							this.resData.drivingPermit = "无"
						}
						if (res.data.regiestationCertificate === 1) {
							this.resData.regiestationCertificate = "有"
						}
						else if (res.data.regiestationCertificate === 2) {
							this.resData.regiestationCertificate = "无"
						}
						if (res.data.newCarInvoice === 1) {
							this.resData.newCarInvoice = "有"
						} else if (res.data.newCarInvoice === 2) {
							this.resData.newCarInvoice = "无"
						}
						if (res.data.newCarGuarantee === 1) {
							this.resData.newCarGuarantee = "保内"
						} else if (res.data.newCarGuarantee === 2) {
							this.resData.newCarGuarantee = "保外"
						}
          } else {
            Toast({
              message: res.msg
            });
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Configure.vue